module.exports = __webpack_public_path__ + "img/enterpriseTrainingImg1.b55d378a.png";